<template>
  <base-dropdown class="nav-item" menu-on-right tag="li" title-tag="a">
    <a slot="title-container" class="nav-link" href="#" role="button">
      <div class="media align-items-center">
        <div class="icon-letter bg-exitos text-accent">
          <div class="image-profile-bg" :style="bg_imagem"></div>
          {{ first_lleter }}
        </div>
      </div>
    </a>

    <div class="dropdown-header noti-title">
      <h6 class="text-overflow m-0">Bem vindo!</h6>
    </div>
    <router-link to="/profile" class="dropdown-item">
      <i class="ni ni-single-02"></i>
      <span>Meu perfil</span>
    </router-link>
    <router-link to="/profile" class="dropdown-item">
      <i class="ni ni-settings-gear-65"></i>
      <span>Configurações</span>
    </router-link>
    <router-link to="/profile" class="dropdown-item">
      <i class="ni ni-calendar-grid-58"></i>
      <span>Atividades</span>
    </router-link>
    <router-link to="/profile" class="dropdown-item">
      <i class="ni ni-support-16"></i>
      <span>Suporte</span>
    </router-link>
    <div class="dropdown-divider"></div>
    <a href="#" @click="logout()" class="dropdown-item">
      <i class="ni ni-user-run"></i>
      <span>Sair</span>
    </a>
  </base-dropdown>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
  computed: {
    ...mapState("auth", ["user"]),
    first_lleter() {
      let firsts = "";
      if (this.user && this.user.name) {
        let matches = this.user.name.match(/\b(\w)/g);
        firsts = matches.join("");
      }
      return firsts.substring(0, 1);
    },
    pessoa_fisica() {
      return this.user.pessoa_fisica ? this.user.pessoa_fisica : {};
    },
    image() {
      let response = this.pessoa_fisica.imagem
        ? this.pessoa_fisica.imagem.url
        : null;
      return response;
    },
    bg_imagem() {
      return this.image ? 'background-image: url("' + this.image + '")' : "";
    },
  },
  methods: {
    ...mapActions("auth", ["ActionSignOut"]),
    async logout() {
      await this.ActionSignOut();
      this.$router.push({ name: "login" });
    },
  },
};
</script>
<style lang="scss" scope>
.icon-letter {
  width: 36px;
  height: 36px;
  line-height: 36px;
  border-radius: 50%;
  text-align: center;
  background-color: #ffffff;
  font-weight: bolder;

  .image-profile-bg {
    width: 36px;
    height: 36px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 36px;
    border-radius: 50%;
    position: absolute;
  }
}
</style>
